import { BuyerCustomerDTO, Permission } from 'core/api';
import { Command } from 'pos/common';
import { CustomerDisplay } from 'pos/services';
import * as SalesStore from '../SalesStore';


declare global {
	interface CommandType {
		updateCurrentTicketCustomer: () => Promise<Result<BuyerCustomerDTO>>
	}
}

Command.register('updateCurrentTicketCustomer', 'NO_PRECONDITION', async (): Promise<Result<BuyerCustomerDTO>> => {
	return Command.execute('setOrRemoveCustomer', {
		customer: SalesStore.getTicket().Customer,
		setCustomer: async (customer: BuyerCustomerDTO) => {
			await SalesStore.setCustomer(customer);
			await CustomerDisplay.displayCustomer(SalesStore.getTicket());
		},
		requiredPermission: Permission.Ticket_SetBuyerCustomer
	});
});


